import { memo, useMemo, type FC } from "react";
import { useTranslation } from "react-i18next";
import type { CampaignChannel } from "src/layouts/Engagements/EngagementInterfaces";
import ChatChoiceStep from "./ChatChoiceStep";
import { getChannelLabelKey } from "./ChatCampaignChoiceConstants";

interface ChatChannelRepliesProps {
  channels: CampaignChannel[];
  onReply: (_text: string) => void;
}

const ChatChannelReplies: FC<ChatChannelRepliesProps> = ({ channels, onReply }) => {
  const { t } = useTranslation();
  const options = useMemo(
    () =>
      channels.map(channel => {
        const label = t(getChannelLabelKey(channel));
        return { value: label, label };
      }),
    [channels, t]
  );

  return (
    <div className="chat-channel-replies">
      <ChatChoiceStep options={options} onSelect={onReply} />
    </div>
  );
};

export default memo(ChatChannelReplies);
